// extracted by mini-css-extract-plugin
export default {"customOption":"Io5Dzgs2Bd2q4tjbGMG8","customOptionLabelDisplay":"Z5_gFiKxDS5LAvQC0NI8","customMultiValueLabel":"ekdoMiMTCAA4NfIh2Syk"};